import React from "react";
import { Box } from "@mui/material";

const Title = ({ title, fontSize }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "95%",
        maxWidth: "1200px",
        margin: "0 auto",
        color: "#000",
        borderBottom: "1px solid #000",
      }}
    >
      <Box
        sx={{
          marginLeft: 1,
          fontSize: fontSize,
          fontWeight: "200",
          marginBottom: 1,
        }}
      >
        {title}
      </Box>
    </Box>
  );
};

export default Title;
